var _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXtraPower(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 130",
    width: 340,
    height: 130,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 130,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 12,
    fill: "#628141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,30 L23,12 L34,30 Z",
    fill: "#ffffff",
    fillOpacity: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 33,
    r: 5,
    fill: "#628141"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 74,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 40,
    fontWeight: 700,
    fill: "#1B211A",
    fillOpacity: 1,
    textAnchor: "start",
    letterSpacing: 0.4
  }, "Xtra Power")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 98,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#628141",
    fillOpacity: 1,
    textAnchor: "start",
    letterSpacing: 3
  }, "POWER TOOLS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtraPower);
export default __webpack_public_path__ + "static/media/xtra-power.d8f4028cc71585569343453279bc0130.svg";
export { ForwardRef as ReactComponent };